import * as React from "react";
import { cn } from "@/lib/utils";

// Lightweight, SSR-safe tooltip shims
// These avoid importing @radix-ui/react-tooltip to prevent runtime hook errors in certain environments.

const TooltipProvider = ({ children }: { children: React.ReactNode } & Record<string, unknown>) => {
  return <>{children}</>;
};

const Tooltip = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

const TooltipTrigger = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, children, ...props }, ref) => (
  <span ref={ref} className={className} {...props}>
    {children}
  </span>
));
TooltipTrigger.displayName = "TooltipTrigger";

const TooltipContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { sideOffset?: number }
>(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    role="tooltip"
    // Hidden by default; this shim does not implement interactive behavior
    className={cn(
      "hidden z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md",
      className,
    )}
    {...props}
  >
    {children}
  </div>
));
TooltipContent.displayName = "TooltipContent";

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
